import { useOnClickInside } from 'hooks/useOnClickInside'
import { dispatch } from 'store'
import { editorThunks } from 'store/features/editor/thunks'

const deselectAll = () => {
  dispatch(editorThunks.deselectAllTimelineItems())
}

export const useDeselectOnEmptyClick = (
  containerId: string,
  ignoredClassNames: string[]
) => {
  useOnClickInside(containerId, deselectAll, ignoredClassNames)
}
